import { useMemo } from "react";
import { colorOfContentMap } from "~/sharedHOC/colorPicker/const";
import { getContrastTextColor } from "~/utils/color";

export const useGetColorOfContent = (backgroundColor: string) =>
    useMemo(() => colorOfContentMap[backgroundColor] ?? getContrastTextColor(backgroundColor), [backgroundColor]);
